<template>
    <InformationPage
        title="About Us"
        description="Learn more about our company, mission, and values."
        :breadcrumb="[
            { icon: 'i-heroicons-home', label: $t('Home'), to: $localePath({ name: 'index' }) },
            { label: $t('About') }
        ]"
    >
    <div class="prose">
        <div class="not-prose mb-8">
            <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=600&fit=crop" 
                alt="Our team collaborating" 
                class="w-full h-64 md:h-96 object-cover rounded-lg shadow-lg"
            />
            <p class="text-sm text-gray-500 mt-2 text-center">Our dedicated team working together to bring you the best experience</p>
        </div>

        <h2>Our Story</h2>
        <p>
            Founded with a passion for delivering exceptional products and outstanding customer service, 
            we've grown from a small startup to a trusted name in e-commerce. Our journey began with a 
            simple mission: to make quality products accessible to everyone, everywhere.
        </p>

        <h2>Our Mission</h2>
        <p>
            We are committed to providing our customers with the best shopping experience possible. 
            By combining cutting-edge technology with personalized service, we strive to exceed 
            expectations at every touchpoint. Our goal is to not just meet your needs, but to 
            anticipate them.
        </p>

        <h2>What We Believe In</h2>
        <ul>
            <li><strong>Quality First:</strong> Every product we offer is carefully selected and thoroughly vetted to ensure it meets our high standards.</li>
            <li><strong>Customer Satisfaction:</strong> Your happiness is our success. We're here to support you before, during, and after your purchase.</li>
            <li><strong>Innovation:</strong> We continuously improve our platform and services to provide you with the best online shopping experience.</li>
            <li><strong>Sustainability:</strong> We're committed to sustainable practices and partnering with brands that share our environmental values.</li>
            <li><strong>Transparency:</strong> Honest communication and fair pricing are at the core of everything we do.</li>
        </ul>

        <h2>Why Choose Us?</h2>
        <p>
            With thousands of products across multiple categories, secure payment options, fast shipping, 
            and a dedicated customer support team, we make online shopping simple, safe, and enjoyable. 
            Whether you're looking for the latest trends or timeless classics, you'll find exactly what 
            you need in our carefully curated collection.
        </p>

        <h2>Our Team</h2>
        <p>
            Behind every great experience is a team of passionate individuals. Our diverse team of experts 
            in technology, design, customer service, and logistics works tirelessly to bring you the best 
            possible shopping experience. We're more than just colleagues—we're a family united by our 
            commitment to excellence.
        </p>

        <h2>Get In Touch</h2>
        <p>
            We love hearing from our customers! Whether you have a question, feedback, or just want to 
            say hello, don't hesitate to <a href="/contact" class="text-primary">reach out to us</a>. 
            Your voice matters, and we're always here to listen.
        </p>
    </div>
    <template #aside>
        <Timeline />
    </template>
</InformationPage>
</template>
<script setup lang="ts">
import InformationPage from '~/components/templates/InformationPage.vue';
import Timeline from '~/components/organisms/Timeline.vue';

definePageMeta({
    layout: 'information',
})
</script>